import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, OnInit, signal, viewChild } from '@angular/core';
import { PopoverDesignTokens } from '@primeuix/themes/types/popover';
import { ReadNotification } from '@shared/models/notifications/read-notification';
import { AuthFacade } from 'app/auth/auth.facade';
import { WebSocketFacade } from 'app/notifications/websocket.facade';
import { MessageService } from 'primeng/api';
import { Button } from "primeng/button";
import { Divider } from "primeng/divider";
import { Popover } from "primeng/popover";

@Component({
  selector: 'app-notifications-popover',
  imports: [Button, Divider, Popover, NgTemplateOutlet],
  templateUrl: './notifications-popover.component.html',
  styles: ``
})
export class NotificationsPopoverComponent implements OnInit{

  readonly appendTo = input<any>();

  readonly notificationPopup = viewChild<Popover>("notificationsPopover")

  readonly notifications = signal<ReadNotification[]>([]);

  readonly existsUnreadNotification = computed(() => {
    var notifications = this.notifications();
    return notifications.filter(n => !n.read).length > 0;
  });

  popoverDt: PopoverDesignTokens = {
    root: {
      arrowOffset: "12px",
      gutter: "0px"
    }
  }

  constructor(
    private webSocketFacade: WebSocketFacade,
    private messageService: MessageService) {
  }

  ngOnInit(): void {
    this.webSocketFacade.subscribeNotificationMessages()?.subscribe({
      next: message => {
        if (!!message.data?.title) {
          this.notifications.set([{read: false, message}, ...this.notifications()]);
          this.messageService.add({ severity: 'info', summary: undefined, detail: message.data.title });
        }
      }
    });
  }

  markNotificationRead(notification: ReadNotification) {
    notification.read = true;
    this.notifications.set([...this.notifications()]);
  }

  deleteNotification(notification: ReadNotification) {
    this.notifications.set([...this.notifications().filter(n => n !== notification)]);
  }
}
